import React from 'react';
import { BackdropStyle, CloseButton, CloseIconImage, ButtonContainer } from './Backdrop.styled';
import CloseWhite from '../../../assets/images/CloseWhite.svg';

const Backdrop = ({
    showBackdrop = false,
    closeBackdrop = () => {},
    isModal = false,
    loaderBackground = false,
    children
}) => {
    return (
        <BackdropStyle
            show={showBackdrop}
            loaderBackground={loaderBackground}
        >
            <CloseButton onClick={closeBackdrop} isModal={isModal}>
                <ButtonContainer>    
                    <CloseIconImage
                        src={CloseWhite}
                        alt="CloseButton"
                    />    
                </ButtonContainer>
            </CloseButton>
            {children}
        </BackdropStyle>
    );
};

Backdrop.defaultProps = {
    showCloseButton: true,
};

export default Backdrop;
